import { useFieldArray } from 'react-hook-form';
import SchoolRecordInput from './SchoolRecordInput';

const ExtracurricularTable = ({ register, control, isRead = false }) => {
    const {
        fields: extracurricular_g10_first_fields,
        append: extracurricular_g10_first_append,
        remove: extracurricular_g10_first_remove,
        move: extracurricular_g10_first_move
    } = useFieldArray({
        control,
        name: 'extracurricular.g10.first',
    });

    const {
        fields: extracurricular_g10_second_fields,
        append: extracurricular_g10_second_append,
        remove: extracurricular_g10_second_remove,
        move: extracurricular_g10_second_move
    } = useFieldArray({
        control,
        name: 'extracurricular.g10.second',
    });

    const {
        fields: extracurricular_g11_first_fields,
        append: extracurricular_g11_first_append,
        remove: extracurricular_g11_first_remove,
        move: extracurricular_g11_first_move
    } = useFieldArray({
        control,
        name: 'extracurricular.g11.first',
    });

    const {
        fields: extracurricular_g11_second_fields,
        append: extracurricular_g11_second_append,
        remove: extracurricular_g11_second_remove,
        move: extracurricular_g11_second_move
    } = useFieldArray({
        control,
        name: 'extracurricular.g11.second',
    });

    const {
        fields: extracurricular_g12_first_fields,
        append: extracurricular_g12_first_append,
        remove: extracurricular_g12_first_remove,
        move: extracurricular_g12_first_move
    } = useFieldArray({
        control,
        name: 'extracurricular.g12.first',
    });

    const {
        fields: extracurricular_g12_second_fields,
        append: extracurricular_g12_second_append,
        remove: extracurricular_g12_second_remove,
        move: extracurricular_g12_second_move
    } = useFieldArray({
        control,
        name: 'extracurricular.g12.second',
    });

    return (
        <table className={`table table-sm table-bordered text-center align-middle`}>
            <colgroup>
                <col width={"50px"}></col>
                <col width={"50px"}></col>
                <col width={"200px"}></col>
                <col width={"100px"}></col>
                <col width={"auto"}></col>
                {!isRead && <col width={"60px"}></col>}
            </colgroup>

            <thead>
                <tr>
                    <th colSpan={2}>Grade</th>
                    <th>Activities</th>
                    <th>Date</th>
                    <th>Details</th>
                    {!isRead && <th></th>}
                </tr>
            </thead>
            <ExtracurricularTbody
                register={register}
                grade={'g10'}
                semester={1}
                fields={extracurricular_g10_first_fields}
                append={extracurricular_g10_first_append}
                remove={extracurricular_g10_first_remove}
                move={extracurricular_g10_first_move}
                isRead={isRead}
            />
            <ExtracurricularTbody
                register={register}
                grade={'g10'}
                semester={2}
                fields={extracurricular_g10_second_fields}
                append={extracurricular_g10_second_append}
                remove={extracurricular_g10_second_remove}
                move={extracurricular_g10_second_move}
                isRead={isRead}
            />

            <ExtracurricularTbody
                register={register}
                grade={'g11'}
                semester={1}
                fields={extracurricular_g11_first_fields}
                append={extracurricular_g11_first_append}
                remove={extracurricular_g11_first_remove}
                move={extracurricular_g11_first_move}
                isRead={isRead}
            />
            <ExtracurricularTbody
                register={register}
                grade={'g11'}
                semester={2}
                fields={extracurricular_g11_second_fields}
                append={extracurricular_g11_second_append}
                remove={extracurricular_g11_second_remove}
                move={extracurricular_g11_second_move}
                isRead={isRead}
            />

            <ExtracurricularTbody
                register={register}
                grade={'g12'}
                semester={1}
                fields={extracurricular_g12_first_fields}
                append={extracurricular_g12_first_append}
                remove={extracurricular_g12_first_remove}
                move={extracurricular_g12_first_move}
                isRead={isRead}
            />
            <ExtracurricularTbody
                register={register}
                grade={'g12'}
                semester={2}
                fields={extracurricular_g12_second_fields}
                append={extracurricular_g12_second_append}
                remove={extracurricular_g12_second_remove}
                move={extracurricular_g12_second_move}
                isRead={isRead}
            />
        </table>
    )
}

const ExtracurricularTbody = ({ register, grade, semester, fields, remove, append, move, isRead }) => {
    let gradeStr = grade.toUpperCase()
    let semesterStr = semester === 1 ? '1st' : '2nd'
    let semesterKey = semester === 1 ? 'first' : 'second'
    return (
        <tbody>
            {fields.map((item, index) => {
                return (
                    <tr key={`extracurricular-${grade}-${semester}-${item.id}`}>
                        {index === 0 &&
                            <>
                                <td rowSpan={fields.length}>{gradeStr}</td>
                                <td rowSpan={fields.length}>{semesterStr}</td>
                            </>
                        }
                        <td>
                            <SchoolRecordInput register={register} name={`extracurricular.${grade}.${semesterKey}.${index}.activity`} isRead={isRead} />
                        </td>
                        <td>
                            <SchoolRecordInput type='date' register={register} name={`extracurricular.${grade}.${semesterKey}.${index}.date`} isRead={isRead} />
                        </td>
                        <td>
                            <SchoolRecordInput register={register} name={`extracurricular.${grade}.${semesterKey}.${index}.detail`} isRead={isRead} />
                        </td>
                        {!isRead &&
                            <td>
                                {/* ⚽순서이동 */}
                                {/* <button type="button" className="btn btn-sm btn-secondary me-1"
                                        onClick={() => move(index, index - 1)}
                                        disabled={index === 0}
                                    >
                                        ▲
                                    </button>
                                    <button type="button" className="btn btn-sm btn-secondary me-1"
                                        onClick={() => move(index, index + 1)}
                                        disabled={index === fields.length - 1}
                                    >
                                        ▼
                                    </button> 
                                */}
                                <button type="button" className="btn btn-sm btn-outline-danger"
                                    onClick={() => remove(index)}
                                >
                                    삭제
                                </button>
                            </td>
                        }

                    </tr>
                )
            })}
            {!isRead
                && <tr>
                    <td colSpan={6}>
                        <button type='button' className='btn btn-sm btn-outline-primary' onClick={() => { append({ activity: '', date: '', detail: '' }) }} >추가</button>
                    </td>
                </tr>
            }
        </tbody>
    )
}

export default ExtracurricularTable